var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRabby = function SvgRabby(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#8a97fe",
    rx: 100,
    ry: 100
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M438.47 279.1c14.481-32.46-57.109-123.147-125.503-160.929-43.111-29.269-88.032-25.248-97.13-12.396-19.966 28.203 66.114 52.102 123.683 79.989-12.375 5.393-24.037 15.071-30.894 27.448-21.463-23.51-68.569-43.756-123.844-27.448-37.248 10.99-68.204 36.898-80.169 76.03a23.3 23.3 0 0 0-9.512-2.016c-12.95 0-23.447 10.533-23.447 23.526s10.498 23.527 23.447 23.527c2.4 0 9.905-1.616 9.905-1.616l119.929.872c-47.962 76.344-85.866 87.504-85.866 100.73 0 13.226 36.267 9.642 49.885 4.712 65.188-23.6 135.204-97.154 147.218-118.328 50.454 6.316 92.856 7.064 102.298-14.101Z",
    fill: "url(#rabby_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m339.515 185.768.009.004c2.668-1.054 2.237-5.009 1.504-8.114-1.684-7.137-30.741-35.927-58.028-48.822-37.179-17.571-64.557-16.666-68.604-8.569 7.573 15.576 42.685 30.199 79.356 45.472 15.646 6.516 31.575 13.15 45.77 20.026l-.007.003Z",
    fill: "url(#rabby_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.332 342.525c-7.519-2.883-16.013-5.529-25.67-7.929 10.297-18.486 12.457-45.853 2.733-63.156-13.647-24.283-30.778-37.208-70.587-37.207-21.895 0-80.845 7.399-81.892 56.776-.11 5.18-.002 9.928.371 14.295l107.648.782c-14.512 23.101-28.104 40.233-40.004 53.261 14.287 3.673 26.077 6.757 36.902 9.588 10.27 2.687 19.671 5.146 29.51 7.665 14.842-10.851 28.796-22.682 40.989-34.075Z",
    fill: "url(#rabby_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.177 300.23c4.397 37.509 25.643 52.209 69.056 56.559 43.413 4.351 68.315 1.432 101.469 4.459 27.689 2.527 52.413 16.685 61.585 11.793 8.254-4.403 3.636-20.312-7.409-30.518-14.317-13.23-34.133-22.428-68.999-25.692 6.949-19.089 5.002-45.854-5.79-60.417-15.603-21.055-44.405-30.574-80.856-26.415-38.084 4.345-74.575 23.158-69.056 70.231Z",
    fill: "url(#rabby_svg__d)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rabby_svg__a",
    x1: 180.445,
    y1: 250.355,
    x2: 435.479,
    y2: 322.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rabby_svg__b",
    x1: 392.428,
    y1: 245.493,
    x2: 207.881,
    y2: 61.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8697FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8697FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rabby_svg__c",
    x1: 297.449,
    y1: 348.969,
    x2: 120.472,
    y2: 247.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8697FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8697FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rabby_svg__d",
    x1: 195.663,
    y1: 248.447,
    x2: 315.584,
    y2: 400.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#D1D8FF"
  })))));
};
export default SvgRabby;